module.exports = __webpack_public_path__ + "img/home_top_app_icon.df50b8c5.png";